import { render } from "./InvoicesRow.vue?vue&type=template&id=2ab9fccc&scoped=true"
import script from "./InvoicesRow.vue?vue&type=script&lang=js"
export * from "./InvoicesRow.vue?vue&type=script&lang=js"

import "./InvoicesRow.vue?vue&type=style&index=0&id=2ab9fccc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab9fccc"]])

export default __exports__